// removed by extract-text-webpack-plugin
module.exports = {"button":"_3MnNz","icon":"_2UukF","facebook":"_3DqWr","twitter":"SoTmV","gPlus":"_12p8Q","link":"_3c0FC"};


//////////////////
// WEBPACK FOOTER
// ./app/components/share-button/share-button.scss
// module id = 877
// module chunks = 3 4 5 6 7